var _g, _text, _line, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNijvonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 300",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#ffffff"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 95)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10,
    height: 60,
    fill: "#1a1a2e",
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,0 20,0 30,60 20,60",
    fill: "#1a1a2e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 10,
    height: 60,
    fill: "#1a1a2e",
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 8,
    r: 5,
    fill: "#4f8ef7"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 158,
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 52,
    fontWeight: 200,
    letterSpacing: 10,
    fill: "#1a1a2e"
  }, "NIJVON")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 170,
    x2: 492,
    y2: 170,
    stroke: "#4f8ef7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 161,
    y: 192,
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 400,
    letterSpacing: 4,
    fill: "#999"
  }, "MAKE IT COOL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNijvonLogo);
export default __webpack_public_path__ + "static/media/nijvon-logo.cb11a9d4b85be782ad23c9d6ba3bfe63.svg";
export { ForwardRef as ReactComponent };